import React from 'react';
import axios from 'axios';
import ValidationTypes from '../../../util/validationTypes';
import useLoadingForm from '../../../hooks/loadingFormHook';
import LoadButton from '../LoadButton';

export default function SettingsBasicInfo() {
    const submitFormHandler = () => {
        return axios.get("https://flash.siwalik.in/delay/500");
    }

    const basicInfoFormRules = {
        email: [
            ValidationTypes.requiredString,
            ValidationTypes.validEmail
        ],
        password: [ValidationTypes.requiredString],
        repeatPassword: [
            ValidationTypes.requiredString,
            {
                usesInternalFormData: true,
                test: (value, formData) => value === formData.password,
                errorMsg: "Passwords must match"
            }
        ]
    }
    const { formData, handleChange, loading, loaded, handleSubmit, errorMapping } = useLoadingForm({
        email: '',
        password: '',
        repeatPassword: ''
    }, submitFormHandler, null, null, basicInfoFormRules);

    return (
        <form className="formDashboard" onSubmit={handleSubmit}>
            <label htmlFor="email">Email Address</label>
            <input 
            className={errorMapping.email && 'form-error-input'}
            type="text"
            name="email"
            value={formData.email}
            placeholder="New Email Address"
            onChange={handleChange} />
            {errorMapping.email && <p className="form-error">{errorMapping.email}</p>}
            <fieldset>
                <legend>Change Password</legend>
                <input 
                className={errorMapping.password && 'form-error-input'}
                aria-labelledby="password"
                type="password"
                name="password"
                value={formData.password}
                placeholder="New Password"
                onChange={handleChange}
                />
                {errorMapping.password && <p className="form-error">{errorMapping.password}</p>}
                <input 
                className={errorMapping.repeatPassword && 'form-error-input'}
                aria-labelledby="repeat password"
                type="password"
                name="repeatPassword"
                value={formData.repeatPassword}
                placeholder="Confirm Password"
                onChange={handleChange} />
                {errorMapping.repeatPassword && <p className="form-error">{errorMapping.repeatPassword}</p>}
            </fieldset>
            <LoadButton
            loading={loading}
            loaded={loaded}
            defaultText="Save!"
            loadingText="Saving"
            loadedText="Saved"
            classes="black"
            theme="white" />
        </form>
    )
}